import { spawn } from 'redux-saga/effects';

import { stormConfigListSagas } from './listModule';

export default function* sagas() {
	yield spawn(stormConfigListSagas);
}
